type ContactApiItem = {
  data?: {
    contact?: {
      key?: string;
      title?: string;
      visible?: boolean;
      cta?: Array<{
        contactSection?: {
          key?: string;
          type?: string;
          author?: string;
          status?: string;
          visible?: boolean;
          content?: Array<{
            headerSection?: {
              key?: string;
              title?: string;
              visible?: boolean;
              description?: string;
              lists?: Array<{
                id?: number | string;
                title?: string;
                description?: string;
                button?: {
                  label?: string;
                };
              }>;
            };
          }>;
        };
      }>;
    };
  };
};

export type NormalizedContact = {
  page: "contact";
  title: string;
  visible: boolean;

  header: {
    title: string;
    description: string;
    visible: boolean;
  };

  items: Array<{
    id: string;
    title: string;
    description: string;
    buttonLabel: string;
  }>;

  section: {
    visible: boolean;
  };

  meta: {
    key: string;
  };
};

export function normalizeContact(item: ContactApiItem): NormalizedContact | null {
  const contact = item?.data?.contact;
  const cta = contact?.cta?.[0];
  const section = cta?.contactSection;
  const header = section?.content?.[0]?.headerSection;

  if (!contact || !cta || !section || !header) return null;

  return {
    page: "contact",
    title: contact.title ?? "",
    visible: Boolean(contact.visible),

    header: {
      title: header.title ?? "",
      description: header.description ?? "",
      visible: Boolean(header.visible),
    },

    items: (header.lists ?? []).map((entry) => ({
      id: String(entry.id ?? ""),
      title: entry.title ?? "",
      description: entry.description ?? "",
      buttonLabel: entry.button?.label ?? "",
    })),

    section: {
      visible: Boolean(section.visible),
    },

    meta: {
      key: contact.key ?? "",
    },
  };
}